export default "__VITE_ASSET__BIN0$TXO__"